/***
 * Created on 2023/9/18
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import ModalDialog from "../../common/modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {apiDelete} from "../../../service/api";
import {useBoundedStore} from 'common/Store';
import {checkQIDFormat} from "common/ServiceUser";

function RemoveQid({qid, ...props}) {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const store = useBoundedStore();
    const qidType = checkQIDFormat(qid) || 'email';

    const removeMutation = useMutation({
        mutationFn: async (data) => await apiDelete(`/ajax/remove_qid_entry`, data),
        onSuccess: data => {
            queryClient.invalidateQueries({queryKey: ["profile"]});
            props.closeModal();
            store.globalAlert.setAlert(t('@Your device {{mobile_device_name}} has been removed@', {mobile_device_name: qid}), 'success', true);
        },
        onError: (error, variables, context) => {}
    })

    return (
        <ModalDialog {...props} title={t('@Remove@')} submitText={t('@Remove@')} submitAction={async ()=> await removeMutation.mutateAsync({qid})}>
            <div className="dialog-content">
                {qidType === 'email' && <p>{t('@Are you sure to delete QNAP ID:@')} <span className="color-primary">{qid}</span> ?</p>}
                {qidType === 'phone' && <p>{t('@You will no longer be able to log in using your phone number. Are you sure you want to remove it from your QNAP ID?@')}</p>}
            </div>
        </ModalDialog>
    );
}

export default RemoveQid;